import CentroCostoService from 'src/modules/centroCosto/centroCostoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'CENTROCOSTO_VIEW';

const centroCostoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: centroCostoViewActions.FIND_STARTED,
      });

      const record = await CentroCostoService.find(id);

      dispatch({
        type: centroCostoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: centroCostoViewActions.FIND_ERROR,
      });

      getHistory().push('/centro-costo');
    }
  },
};

export default centroCostoViewActions;
